import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useLang } from '@/context/LanguageContext';

const HeroSection = () => {
  const { t } = useLang();

  return (
    <section data-testid="hero-section" className="relative h-screen min-h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/hero-redhouse-v3.jpg"
          alt="Red House Residency"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/25 to-black/10" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-14 md:pb-20 px-5 md:px-10 lg:px-14">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="max-w-2xl"
        >
          <p
            data-testid="hero-subtitle"
            className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-white/75 mb-4"
          >
            {t('hero.subtitle')}
          </p>

          <h1
            data-testid="hero-title"
            className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[0.95] mb-5 whitespace-pre-line"
          >
            {t('hero.title')}
          </h1>

          <p
            data-testid="hero-description"
            className="text-sm sm:text-base text-white/80 max-w-lg leading-relaxed mb-8"
          >
            {t('hero.desc')}
          </p>

          <div className="flex flex-wrap gap-3">
            <Link to="/inquiry" data-testid="hero-cta" className="btn-primary rounded">
              {t('hero.cta')}
            </Link>
            <button
              onClick={() => document.querySelector('#experience')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="hero-discover"
              className="btn-outline-white rounded"
            >
              {t('hero.discover')}
            </button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.6 }}
          className="absolute bottom-5 left-1/2 -translate-x-1/2"
        >
          <ChevronDown className="text-white/30 animate-bounce" size={18} />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
